/**
 * Interwork Marketing i18n — uz (default) | ru | en
 * Mini implementatsiya (react-i18next yo'q). Nested keys: t("marketing.nav.campaigns")
 */

export type Language = "uz" | "ru" | "en";

export const DEFAULT_LANGUAGE: Language = "uz";

export const SUPPORTED_LANGUAGES: Language[] = ["uz", "ru", "en"];

export function isLanguage(v: string | null | undefined): v is Language {
  return v === "uz" || v === "ru" || v === "en";
}

export type Dictionary = {
  [key: string]: string | Dictionary;
};

export interface I18nContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, vars?: Record<string, string | number>) => string;
}
